import AllTreeListPage from './AllTreeListPage';

export default AllTreeListPage;
